<template>
  <div class="view-details-parts" v-if="showFlag">
    <div class="view-details-body">
      <div class="search-body" style="padding: 0;align-items: flex-start;min-height: 40px;">
        <h-search-new ref="searchDiv" :searchParam="searchParam" :showSenior="showSenior" @search="getSearch" @clear="clearCondition" :showBack='true' @backPage='backPage'>
          <template v-slot>
            <div class="search-other-but-part">
              <!-- 用来插入搜索模块的按钮 -->
              <slot name="search"></slot>
            </div>
          </template>
        </h-search-new>
      </div>
      <div class="view-details-type">
        <h-data-classify :dataTypeList='classifyList' @click="changeClassify"></h-data-classify>
      </div>
      <div class="view-details-table">
        <el-table :data="tableData" stripe style="width: 100%" height="100%" highlight-current-row v-loading="loading" @row-click="rowclick" @cell-click="cellClick">
          <el-table-column v-for="(item,i) in tableColumn" :key="i" :prop="item.prop" :label="item.label" :width="item.width?item.width:''">
            <template slot-scope="scope">
              <div v-if="!detailsParam.tableSelf || detailsParam.tableSelfFun(scope.row,item.prop)">{{scope.row[item.prop]}}</div>
              <el-tag v-else size="danger">{{ scope.row[item.prop] }}</el-tag>
            </template>
          </el-table-column>
          <!-- 用来插入表格的操作按钮 -->
          <slot name="table"></slot>
        </el-table>
      </div>
      <div class="table-pagination">
        <h-pagination :total="total" @currentChange="currentChange" @sizeChange="sizeChange"></h-pagination>
      </div>
    </div>
  </div>
</template>

<script>
/*
此组件有两个插槽分别的搜索模块后面的按钮、table的字段

rowData:{}//点击行的数据
showFlag:true//开关
detailsParam: {
        search: {},//跟搜索组件传值一样
        showSenior:'',//是否显示高级搜索
        classify: [],//跟分类组件传值一样
        tableColumn: [
          { prop: 'studentName', label: '姓名', width: '180' },
        ],//表格的字段
        tableSelf: true,//是否开启表格字段个性化（el-tag），若开启必需要tableSelfFun函数
        tableSelfFun: (val, key) => {
          if (val && key == 'auditStatusName') {
            if (val.auditStatus == 'REVIEW_REFUSE') {
              return false
            } else {
              return true
            }
          } else {
            return true
          }
        },//用来判断什么添加下字段添加个性化样式（el-tag）
        apiName:{
          getData:'',
        },//接口API的名
        conditions:{
          //查询使用的条件
          getData: {
            //取条件值的地方
            rowData: {
              //对象的key是取值的对象的key,对象的value用于接口传值的key
              planClassId: 'planClassId',
              id: 'planId',
            },
            //分类使用
            classify: {
              key: 'applyStatusList',
            },
          },
        },
        foirstSrearch:true,//是否首次查询
        dealDataFun:(val,type)=>{return},//处理数据函数
        tableDataTest:[],//用于接口还未提供测试table使用
      },
classifyFun:点击分类回传状态函数
close 返回函数
rowclick table 行点击函数
cellClick table 单元格点击函数
tableDataTest:[]
*/
import HDataClassify from './h-data-classify.vue'
import HSearchNew from './h-search-new.vue'
import HPagination from './h-pagination.vue'

export default {
  props: {
    showFlag: {
      type: Boolean,
      default: false,
    },
    rowData: {
      type: Object,
    },
    detailsParam: {
      type: Object,
    },
    roleType: {
      type: String,
      default: '',
    },
    tableDataTest: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  components: { HSearchNew, HDataClassify, HPagination },
  data() {
    return {
      loading: false,
      tableData: [],
      tableColumn: [],
      pageIndex: 1,
      pageSize: 10,
      total: 0,
      searchData: {},
      searchParam: {},
      classifyList: [],
      classifyIndex: 0, //分类选中索引
      applyStatus: null,
      conditions: {}, //特殊接口调用条件
      showSenior: true,
    }
  },
  watch: {
    showFlag: {
      handler(value) {
        if (value) {
          console.log('detailsParam:', this.detailsParam)
          this.searchParam = this.detailsParam.search
          this.showSenior = this.detailsParam.showSenior
          this.classifyList = this.detailsParam.classify
          this.tableColumn = this.detailsParam.tableColumn
          this.conditions = this.detailsParam.conditions
          if (this.detailsParam.tableDataTest) {
            this.tableData = this.detailsParam.tableDataTest
          }
          if (this.detailsParam.foirstSrearch) {
            this.getTableData()
          }
        }
      },
      immediate: true,
    },
  },
  mounted() {},
  methods: {
    getTableData() {
      this.loading = true
      let data = {}
      //查询条件
      for (const key in this.searchData) {
        data[key] = this.searchData[key]
      }
      //接口要求的其他查询条件
      if (this.conditions && this.conditions.getData) {
        for (const key in this.conditions.getData) {
          if (key == 'rowData') {
            for (const inkey in this.conditions.getData[key]) {
              data[this.conditions.getData[key][inkey]] = this.rowData[inkey]
            }
          } else if (key == 'classify') {
            if (this.applyStatus) {
              data[this.conditions.getData[key].key] = this.applyStatus
            }
          }
        }
      }

      data.current = this.pageIndex
      data.size = this.pageSize
      console.log('data:', data)

      this.$API[this.detailsParam.apiName.getData](data).then((res) => {
        console.log('getApplyTicketStudents:', res)
        if (res.code == '10000') {
          this.total = Number(res.data.total)
          if (this.detailsParam.dealDataFun) {
            this.tableData = this.detailsParam.dealDataFun(res.data.records)
          } else {
            this.tableData = res.data.records
          }
          this.loading = false
        } else {
          this.$message({
            message: res.message,
            duration: 3000,
            type: 'warning',
          })
        }
      })
    },
    backPage() {
      this.tableData = []
      this.pageIndex = 1
      this.pageSize = 10
      this.total = 0
      this.searchData = {}
      this.applyStatus = null
      this.classifyIndex = 0
      this.$emit('close')
    },
    changeClassify(index) {
      console.log(index)
      this.classifyIndex = index
      this.applyStatus = this.classifyList[index].value
      this.pageIndex = 1
      this.pageSize = 10
      if (this.$listeners['classifyFun']) {
        this.$emit('classifyFun', this.applyStatus)
      }
      this.getTableData()
    },
    getSearch(param) {
      console.log('param', param)
      this.pageIndex = 1
      if (JSON.stringify(param) != '{}') {
        this.searchData = {}
        let calssKeys = ['facultyId', 'majorId', 'classId']
        for (let item in param) {
          if (item == 'classGroup') {
            for (let i = 0; i < calssKeys.length; i++) {
              if (param[item][i]) {
                this.searchData[calssKeys[i]] = param[item][i]
              } else {
                this.searchData[calssKeys[i]] = null
              }
            }
          } else {
            this.searchData[item] = param[item]
          }
        }
      } else {
        this.searchData = {}
      }

      this.getTableData()
    },
    rowclick(row, column, event) {
      if (this._events.rowclick) {
        this.$emit('rowclick', row, column, cell, event)
      }
    },
    cellClick(row, column, cell, event) {
      if (this._events.cellClick) {
        this.$emit('cellClick', row, column, cell, event)
      }
    },
    clearCondition() {
      this.searchData = {}
      this.getTableData()
    },
    // 分页导航
    currentChange(val) {
      this.pageIndex = val
      this.getTableData()
    },
    //改变单页显示数量
    sizeChange(val) {
      this.pageSize = val
      this.getTableData()
    },
  },
}
</script>

<style lang="less" scoped>
.displayFlex {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.view-details-parts {
  width: 100%;
  height: 100%;
  padding: 23px 29px 21px 29px;
  // position: relative;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 94;
  .view-details-body {
    width: 100%;
    height: 100%;
    padding: 23px 29px 21px 29px;
    background: #ffffff;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .view-details-type {
      .displayFlex;
      justify-content: flex-start;
      width: 100%;
      margin-top: 36px;
    }
    .view-details-table {
      width: 100%;
      margin-top: 20px;
      // height: 610px;
      flex: 1;
      overflow-y: auto;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/parts/h-view-details.vue